import { isJson } from "@shared/components/form-builder/utils";

// workaround to set necessarry language_profile_id prop:
export const formatLangProfileData = (data) => {
  if (!data) return null;

  const { profile_id, language_profile_id, ...rest } = data;

  return {
    ...rest,
    language_profile_id: profile_id || language_profile_id,
  }
}

export const compareWithCached = (langProfile) => {
  const cachedLangProfile = localStorage.getItem("lang_profile");
  const cachedLangProfileParsed = isJson(cachedLangProfile) ? JSON.parse(cachedLangProfile) : null; // check if cachedLangProfile is a valid JSON string
  const cachedTranslations = localStorage.getItem("translations");

  const cachedLangProfileId = cachedLangProfileParsed?.language_profile_id;
  const currentLangProfileId = langProfile?.language_profile_id;

  const cachedLangProfileVersion = cachedLangProfileParsed?.version;
  const currentLangProfileVersion = langProfile?.version;

  const isLangProfileChanged = cachedLangProfileId !== currentLangProfileId;
  const isLangProfileVersionChanged = cachedLangProfileVersion !== currentLangProfileVersion;

  return {
    profileChanged: isLangProfileChanged,
    versionChanged: isLangProfileVersionChanged,
    cachedTranslations,
    currentLangProfile: langProfile,
    currentLangProfileId,
    currentLangProfileVersion,
    cachedLangProfile: cachedLangProfileParsed,
    cachedLangProfileId,
    cachedLangProfileVersion,
  }
}